import { cn } from '#app/utils/misc.tsx'

type Tone = 'ink' | 'ink-soft' | 'cream'

const toneClass: Record<Tone, string> = {
	ink: 'bg-ink text-ink-fg',
	'ink-soft': 'bg-ink-soft text-ink-fg',
	cream: 'marketing-cream text-cream-fg',
}

export function MarketingSection({
	tone = 'ink',
	className,
	containerClassName,
	children,
}: {
	tone?: Tone
	className?: string
	containerClassName?: string
	children: React.ReactNode
}) {
	return (
		<section className={cn('relative w-full', toneClass[tone], className)}>
			<div
				className={cn(
					'mx-auto w-full max-w-5xl px-6 py-20 md:px-10 md:py-28',
					containerClassName,
				)}
			>
				{children}
			</div>
		</section>
	)
}
